<template>
  <modal
    name="checkGiftCardBalanceModal"
    modal-style="compact"
    @closed="handleCloseModal"
  >
    <check-gift-card-balance />
  </modal>
</template>


<script>
  import events from '@/services/events';

  import CheckGiftCardBalance from './check-gift-card-balance/index.vue';

  export default {
    name: 'CheckGiftCardBalanceModal',

    components: {
      CheckGiftCardBalance
    },

    methods: {
      handleCloseModal() {
        /** Note:
         * Need to emit event so the menu view details will re-route accordingly if user opened this modal via deep link.
         */
        events.emit('check-balance:close');
      }
    }
  };
</script>
